const OffersBody = () => {
  return (
    <section className="offers section-spacing-50">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="center ntuna-dark-secondary">
              <p>
                We have no discount offers at this time. Please check again
                later.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OffersBody;
